<div class="objectives-content__property">
  <div class="title-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15 12.9999H14V5.99992C14 5.7347 13.8946 5.48035 13.7071 5.29281C13.5196 5.10527 13.2652 4.99992 13 4.99992H9V1.99992C9.00012 1.81883 8.95106 1.64111 8.85807 1.48573C8.76507 1.33035 8.63163 1.20313 8.47199 1.11766C8.31234 1.03219 8.13248 0.991676 7.95161 1.00044C7.77073 1.0092 7.59564 1.06692 7.445 1.16742L2.445 4.49992C2.30784 4.59143 2.19543 4.71544 2.11779 4.86091C2.04015 5.00637 1.99969 5.16878 2 5.33367V12.9999H1C0.867392 12.9999 0.740215 13.0526 0.646447 13.1464C0.552678 13.2401 0.5 13.3673 0.5 13.4999C0.5 13.6325 0.552678 13.7597 0.646447 13.8535C0.740215 13.9472 0.867392 13.9999 1 13.9999H15C15.1326 13.9999 15.2598 13.9472 15.3536 13.8535C15.4473 13.7597 15.5 13.6325 15.5 13.4999C15.5 13.3673 15.4473 13.2401 15.3536 13.1464C15.2598 13.0526 15.1326 12.9999 15 12.9999ZM13 5.99992V12.9999H9V5.99992H13ZM3 5.33367L8 1.99992V12.9999H3V5.33367ZM7 6.99992V7.99992C7 8.13253 6.94732 8.2597 6.85355 8.35347C6.75979 8.44724 6.63261 8.49992 6.5 8.49992C6.36739 8.49992 6.24021 8.44724 6.14645 8.35347C6.05268 8.2597 6 8.13253 6 7.99992V6.99992C6 6.86731 6.05268 6.74013 6.14645 6.64636C6.24021 6.5526 6.36739 6.49992 6.5 6.49992C6.63261 6.49992 6.75979 6.5526 6.85355 6.64636C6.94732 6.74013 7 6.86731 7 6.99992ZM5 6.99992V7.99992C5 8.13253 4.94732 8.2597 4.85355 8.35347C4.75979 8.44724 4.63261 8.49992 4.5 8.49992C4.36739 8.49992 4.24021 8.44724 4.14645 8.35347C4.05268 8.2597 4 8.13253 4 7.99992V6.99992C4 6.86731 4.05268 6.74013 4.14645 6.64636C4.24021 6.5526 4.36739 6.49992 4.5 6.49992C4.63261 6.49992 4.75979 6.5526 4.85355 6.64636C4.94732 6.74013 5 6.86731 5 6.99992ZM5 10.4999V11.4999C5 11.6325 4.94732 11.7597 4.85355 11.8535C4.75979 11.9472 4.63261 11.9999 4.5 11.9999C4.36739 11.9999 4.24021 11.9472 4.14645 11.8535C4.05268 11.7597 4 11.6325 4 11.4999V10.4999C4 10.3673 4.05268 10.2401 4.14645 10.1464C4.24021 10.0526 4.36739 9.99992 4.5 9.99992C4.63261 9.99992 4.75979 10.0526 4.85355 10.1464C4.94732 10.2401 5 10.3673 5 10.4999ZM7 10.4999V11.4999C7 11.6325 6.94732 11.7597 6.85355 11.8535C6.75979 11.9472 6.63261 11.9999 6.5 11.9999C6.36739 11.9999 6.24021 11.9472 6.14645 11.8535C6.05268 11.7597 6 11.6325 6 11.4999V10.4999C6 10.3673 6.05268 10.2401 6.14645 10.1464C6.24021 10.0526 6.36739 9.99992 6.5 9.99992C6.63261 9.99992 6.75979 10.0526 6.85355 10.1464C6.94732 10.2401 7 10.3673 7 10.4999Z"
        fill="#CC9213"
      />
    </svg>
    <h2 class="heading-h2">Imóvel próprio ou Investimento imobiliário</h2>
  </div>

  <div class="property-reason">
    <h3 class="heading-h3">Escolheu esse objetivo porque</h3>
    <p>
      {{ dataStoreProperty.description }}
    </p>

    <h3 class="heading-h3">Quando deseja realizar esse objetivo?</h3>
    <p>{{ intendDate }}</p>
  </div>

  <h3 class="heading-h3">Quanto pretende investir nesse objetivo?</h3>
  <div class="pretend-invest-container">
    <div class="invest__min">
      <h4 class="heading-h4">Minimo</h4>
      <p>{{ minInvestimentFormated }} /mês</p>
    </div>
    <div class="invest__max">
      <h4 class="heading-h4">Maximo</h4>
      <p>{{ maxInvestimentFormated }} /mês</p>
    </div>
  </div>

  <div>
    <h3 class="heading-h3">Observações</h3>
    <p>
      {{ dataStoreProperty.observation }}
    </p>
  </div>
</div>
